/* eslint-disable camelcase */
export interface GridConfig {
    gridCalculation: {
        [key in number]: {
            column: number;
            gutter: number;
        };
    };
    bannerRatio: {
        h: {
            [key in string]: number;
        };
        v: {
            [key in string]: number;
        };
    };
    columns: number[];
    filteredGrid?: {
        [key: string]: {
            size?: {
                width: number;
                height: number;
            };
            delivery_promise_148?: number;
        };
        extraHeight: {
            delivery_promise_148: number;
        };
    };
    minWidth: number;
    gridImagesNames?: {
        [key: string]: string;
    };
}

export interface GridsConfig {
    open: GridConfig;
    upcoming: GridConfig;
    reco: GridConfig;
}

export default {
    open: {
        gridCalculation: {
            5: {
                column: 18.4501845018,
                gutter: 1.937269373,
            },
            4: {
                column: 23.1749710313,
                gutter: 2.433371958,
            },
            3: {
                column: 31.15264798,
                gutter: 3.271028037,
            },
            2: {
                column: 47.50593824,
                gutter: 4.988123515,
            },
            1: {
                column: 100,
                gutter: 3,
            },
        },
        bannerRatio: {
            h: {
                1: 1,
                2: 2.105,
            },
            v: {
                1: 1.2857142857,
                2: 2.6764285714,
            },
        },
        columns: [4, 3, 2],
        filteredGrid: {
            5: {
                size: {
                    width: 1,
                    height: 1,
                },
            },
            4: {
                size: {
                    width: 1,
                    height: 1,
                },
            },
            3: {
                size: {
                    width: 1,
                    height: 1,
                },
            },
            2: {
                size: {
                    width: 1,
                    height: 1,
                },
            },
            1: {
                size: {
                    width: 2,
                    height: 1,
                },
            },
            extraHeight: {
                delivery_promise_148: 31,
            },
        },
        minWidth: 250,
        gridImagesNames: {
            '1x1': '1x1',
            '2x1': '2x1',
            '1x2': '1x2',
            '2x2': '2x2',
        },
    },
    upcoming: {
        gridCalculation: {
            4: {
                column: 23.8208670796,
                gutter: 1.5721772273,
            },
            3: {
                column: 31.9284802043,
                gutter: 2.1072796935,
            },
            2: {
                column: 48.4027105518,
                gutter: 3.1945788964,
            },
            1: {
                column: 100,
                gutter: 3,
            },
        },
        bannerRatio: {
            h: {
                1: 1,
                2: 2.066,
            },
            v: {
                1: 0.5,
                2: 1.066,
            },
        },
        columns: [4, 3, 2, 1],
        minWidth: 300,
        gridImagesNames: {
            '1x1': '1x1',
            '2x1': '2x1',
            '1x2': '1x2',
            '2x2': '2x2',
        },
    },
    reco: {
        gridCalculation: {
            7: {
                column: 12.1428571429,
                gutter: 2.5,
            },
            6: {
                column: 14.5833333333,
                gutter: 2.5,
            },
            5: {
                column: 18,
                gutter: 2.5,
            },
            4: {
                column: 23.125,
                gutter: 2.5,
            },
        },
        columns: [7, 6, 5, 4],
        bannerRatio: {
            h: {
                1: 1,
            },
            v: {
                1: 1.43703703704,
            },
        },
        minWidth: 135,
    },
} as GridsConfig;
